import { useActiveLocation } from "../activeLocation";
import { DockStatusView } from "./DockStatusView";
import { useDockStatus } from "./useDockStatus";
import { useReturnUnit } from "../returnUnit/useReturnUnit";
import { ConfirmModal } from "../ConfirmModal";
import { Dock } from "./types";

export function createDockStatus(managementBase: string) {
  return function DockStatus() {
    const { locationId, name } = useActiveLocation();
    const query = useDockStatus(locationId);

    const ret = useReturnUnit<Dock>({
      managementBase,
      invalidateKey: ["dockStatus", locationId],
      getUnitId: (dock) => dock.currentUnitId,
    });

    const returningDockId = ret.isPending ? ret.pending?.id ?? null : null;

    return (
      <>
        <DockStatusView
          data={query.data}
          isLoading={query.isLoading}
          isError={query.isError}
          error={query.error}
          locationLabel={name}
          onReturnUnit={ret.open}
          returningDockId={returningDockId}
        />

        <ConfirmModal
          opened={ret.pending !== null}
          onClose={ret.close}
          onConfirm={ret.confirm}
          isPending={ret.isPending}
          title="Return Unit to Storage"
          confirmLabel="Return Unit"
        >
          Return unit {ret.pending?.unitNumber} from {ret.pending?.name} to storage?
          The robot will move the unit off the dock.
        </ConfirmModal>
      </>
    );
  };
}
